import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortThunderboltIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_314"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_314)">
        <path
          d="M4.0625 6.94281C3.94647 6.94281 3.83519 6.9889 3.75314 7.07095C3.67109 7.15299 3.625 7.26427 3.625 7.38031V8.25531C3.625 8.37134 3.67109 8.48262 3.75314 8.56467C3.83519 8.64671 3.94647 8.69281 4.0625 8.69281H11.9375C12.0535 8.69281 12.1648 8.64671 12.2469 8.56467C12.3289 8.48262 12.375 8.37134 12.375 8.25531V7.38031C12.375 7.26427 12.3289 7.15299 12.2469 7.07095C12.1648 6.9889 12.0535 6.94281 11.9375 6.94281H4.0625Z"
          fill={color}
        />
        <path
          d="M1.875 3.01819C1.64294 3.01819 1.42038 3.11038 1.25628 3.27447C1.09219 3.43856 1 3.66112 1 3.89319V10.6128C1.00005 10.8448 1.09227 11.0673 1.25638 11.2314L2.75 12.725C2.91406 12.8891 3.13658 12.9813 3.36862 12.9814H12.6314C12.8634 12.9813 13.0859 12.8891 13.25 12.725L14.7436 11.2314C14.9077 11.0673 15 10.8448 15 10.6128V3.89319C15 3.66112 14.9078 3.43856 14.7437 3.27447C14.5796 3.11038 14.3571 3.01819 14.125 3.01819H1.875ZM2 4.00005H14V10.6128L12.6314 12H3.3885L2 10.6128V4.00005Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortThunderboltIcon.displayName = 'PortThunderboltIcon';
